import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const LinksContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export const LinkCount = styled.p`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;
